/**
 * @enum {number}
 */
export const AuctionPriorityDiscount = {
    HIGH: 80,
    MEDIUM: 50,
    LOW: 0,
};

/**
 * Determines the auction priority status type based on the provided discount percentage.
 *
 * @param {number} discount The discount percentage
 * @returns {string} The auction priority status type
 */
function getAuctionPriorityStatusType(discount) {
    switch (true) {
        case discount >= AuctionPriorityDiscount.HIGH:
            return 'high';
        case discount >= AuctionPriorityDiscount.MEDIUM:
            return 'medium';
        default:
            return 'low';
    }
}

/**
 * Updates the auction priority status component based on the provided discount percentage.
 *
 * @param {Object} options The options object
 * @param {Element=} options.container Optional container element
 * @param {number=} options.discount Optional discount percentage
 */
export function updateAuctionPriorityStatus({ container = document.body, discount = AuctionPriorityDiscount.LOW }) {
    const type = getAuctionPriorityStatusType(discount);

    container.querySelectorAll('.js-priority-status').forEach((el) => {
        el.classList.add('hidden');
    });

    const targetEl = container.querySelector(`.js-priority-status-${type}`);
    targetEl?.classList.remove('hidden');
}
